module.exports = __webpack_public_path__ + "img/Tom-Straphel.26e76766.jpg";